import React from "react";
import { AreaChart, Area, ResponsiveContainer, XAxis, Tooltip } from "recharts";
import { Send, CheckCheck, Eye, MessageSquare } from "lucide-react";

const trend = [
  { d: "Mon", v: 1200 }, { d: "Tue", v: 2100 }, { d: "Wed", v: 1800 },
  { d: "Thu", v: 2600 }, { d: "Fri", v: 3200 }, { d: "Sat", v: 2400 }, { d: "Sun", v: 2900 },
];

const rows = [
  { name: "Diwali Offer", audience: "Retail · 12,400", status: "Delivered", when: "2h ago" },
  { name: "Loan EMI Reminder", audience: "BFSI · 8,900", status: "Sending", when: "just now" },
  { name: "New Arrivals", audience: "E-com · 21,300", status: "Scheduled", when: "Tomorrow" },
];

const statusTone = {
  Delivered: "bg-green-50 text-green-600",
  Sending: "bg-blue-50 text-blue-600",
  Scheduled: "bg-amber-50 text-amber-600",
};

/**
 * Illustrative WhatsApp campaign dashboard mockup (demo data only).
 */
export const CampaignDashboard = () => {
  return (
    <div className="et-card p-5 sm:p-6" data-testid="campaign-dashboard-mock">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-sm font-semibold text-slate-900">Campaign Overview</div>
          <div className="text-[11px] text-slate-400">Illustrative demonstration · not real customer data</div>
        </div>
        <span className="rounded-full bg-slate-100 px-2.5 py-1 text-[10px] font-semibold text-slate-500">Demo</span>
      </div>

      <div className="mt-5 grid grid-cols-2 lg:grid-cols-4 gap-3">
        <Kpi icon={Send} label="Recipients" value="42,600" tone="blue" />
        <Kpi icon={CheckCheck} label="Delivered" value="41,180" tone="green" />
        <Kpi icon={Eye} label="Read" value="33,940" tone="violet" />
        <Kpi icon={MessageSquare} label="Responses" value="6,210" tone="amber" />
      </div>

      <div className="mt-5 rounded-xl border border-slate-100 p-4">
        <div className="text-xs font-semibold text-slate-700 mb-2">Delivery trend (7 days)</div>
        <div className="h-32">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={trend} margin={{ top: 6, right: 6, bottom: 0, left: 0 }}>
              <defs>
                <linearGradient id="campGrad" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#2563EB" stopOpacity={0.3} />
                  <stop offset="100%" stopColor="#2563EB" stopOpacity={0} />
                </linearGradient>
              </defs>
              <XAxis dataKey="d" tick={{ fontSize: 10, fill: "#94a3b8" }} axisLine={false} tickLine={false} />
              <Tooltip contentStyle={{ borderRadius: 12, border: "1px solid #e2e8f0", fontSize: 12 }} />
              <Area type="monotone" dataKey="v" stroke="#2563EB" strokeWidth={2.5} fill="url(#campGrad)" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="mt-5 overflow-hidden rounded-xl border border-slate-100">
        <table className="w-full text-left">
          <thead className="bg-slate-50">
            <tr className="text-[10px] uppercase tracking-wide text-slate-400">
              <th className="px-4 py-2 font-semibold">Campaign</th>
              <th className="px-4 py-2 font-semibold hidden sm:table-cell">Audience</th>
              <th className="px-4 py-2 font-semibold">Status</th>
              <th className="px-4 py-2 font-semibold hidden sm:table-cell">When</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {rows.map((r) => (
              <tr key={r.name} className="text-xs">
                <td className="px-4 py-3 font-medium text-slate-800">{r.name}</td>
                <td className="px-4 py-3 text-slate-500 hidden sm:table-cell">{r.audience}</td>
                <td className="px-4 py-3"><span className={`rounded-full px-2 py-0.5 text-[10px] font-semibold ${statusTone[r.status]}`}>{r.status}</span></td>
                <td className="px-4 py-3 text-slate-400 hidden sm:table-cell">{r.when}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const toneMap = {
  blue: "bg-blue-50 text-blue-600",
  green: "bg-green-50 text-green-600",
  violet: "bg-violet-50 text-violet-600",
  amber: "bg-amber-50 text-amber-600",
};
const Kpi = ({ icon: Icon, label, value, tone }) => (
  <div className="rounded-xl border border-slate-100 p-3">
    <span className={`inline-flex h-8 w-8 items-center justify-center rounded-lg ${toneMap[tone]}`}><Icon className="h-4 w-4" /></span>
    <div className="mt-2 text-[10px] font-medium text-slate-400">{label}</div>
    <div className="font-display text-lg font-bold text-slate-900">{value}</div>
  </div>
);
